import { useTranslation } from 'react-i18next';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { MobileStepper } from './components/MobileStepper';
import { Step } from './components/Step';
import { type StepperProps } from './types';

export const Stepper = ({
  steps,
  currentStep,
  i18nKey,
  i18nNs = LOCIZE_NS.COMMON,
  onMobileBack,
  className,
}: StepperProps): React.ReactElement => {
  const { t } = useTranslation(i18nNs);
  const currentLabel = steps[currentStep - 1]
    ? t(`${i18nKey}.${steps[currentStep - 1].name}.stepTitle`)
    : '';

  return (
    <div className={className}>
      <div className="hidden am-lg:flex items-start px-4">
        {steps.map((step, index) => (
          <div
            key={step.id}
            className={cn('flex items-start', index < steps.length - 1 ? 'flex-1' : 'shrink-0')}
          >
            <Step
              id={step.id}
              label={t(`${i18nKey}.${step.name}.stepTitle`)}
              active={currentStep === step.id}
              completed={currentStep > step.id}
            />
            {index < steps.length - 1 && (
              <div className="h-6 flex-1 px-2 pt-3">
                <div
                  className={cn(
                    'w-full border-t border-dashed',
                    currentStep > index + 1 ? 'border-teal-600' : 'border-plum-300'
                  )}
                />
              </div>
            )}
          </div>
        ))}
      </div>
      <MobileStepper
        currentStep={currentStep}
        steps={steps}
        label={currentLabel}
        onBack={onMobileBack}
      />
    </div>
  );
};
